export const SHOW_SPINNER = (state, spinner) => {
  state.spinner = {
    show: true,
    title: spinner.title,
    subtitle: spinner.subtitle
  };
};

export const HIDE_SPINNER = state => {
  state.spinner = {
    show: false,
    title: "",
    subtitle: ""
  };
};

export const SET_SCROLL_BLOCK = (state, block) => {
  state.scrollBlock.block = block;
};

export const SET_POSITION_SCROLL_Y = (state, scrollY) => {
  state.scrollBlock.positionScrollY = scrollY;
};

export const SHOW_NOTIFICATION = (state, data) => {
  state.notification = {
    show: true,
    message: data.message,
    type: data.type
  };
};

export const HIDE_NOTIFICATION = state => {
  state.notification = {
    show: false,
    message: "",
    type: ""
  };
};

export const SHOW_MODAL = (state, type) => {
  state.modal = {
    show: true,
    type
  };
};

export const HIDE_MODAL = state => {
  state.modal = {
    show: false,
    type: null
  };
};

export const STATE_CONNECTION = (state, connected) => {
  state.connected = connected;
};
